import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { ProductExperience } from '../components/ProductExperience';
import { CompetitiveEdge } from '../components/CompetitiveEdge';
import { CaseStudy } from '../components/CaseStudy';
import { LeadershipSection } from '../components/LeadershipSection';
import { FinalCTA } from '../components/FinalCTA';
export function FemEntityLanding() {
  return <main className="min-h-screen bg-ivory font-sans text-charcoal selection:bg-purple-200 selection:text-charcoal" data-id="element-352">
      {/* Navigation placeholder - minimal for landing page */}
      <nav className="absolute top-0 left-0 right-0 z-50 px-6 py-6 flex justify-between items-center max-w-7xl mx-auto" data-id="element-353">
        <img src="https://cdn.magicpatterns.com/uploads/xpYure8muF9bisffxXgVg2/fementity.png" alt="Fem Entity" className="h-12 md:h-16 drop-shadow-lg" data-id="element-354" />
        <div className="hidden md:flex space-x-8 text-sm font-medium text-charcoal/80" data-id="element-355">
          <a href="/practitioners" className="hover:text-purple-700 transition-colors" data-id="element-356">
            Practitioners
          </a>
          <a href="/investors" className="hover:text-purple-700 transition-colors" data-id="element-357">
            Investors
          </a>
        </div>
      </nav>

      <Hero data-id="element-358" />
      <ProblemSection data-id="element-359" />
      <CaseStudy data-id="element-360" />
      <SolutionSection data-id="element-361" />
      <ProductExperience data-id="element-362" />
      <CompetitiveEdge data-id="element-363" />
      <LeadershipSection data-id="element-364" />
      <FinalCTA data-id="element-365" />

      {/* Minimal Footer */}
      <footer className="bg-charcoal text-ivory/50 py-8 text-center text-sm border-t border-white/10" data-id="element-366">
        <p data-id="element-367">© {new Date().getFullYear()} Fem Entity. All rights reserved.</p>
      </footer>
    </main>;
}